import { IOwnerVisitsData } from "../types/ownerDashboard.types";
import { PropertyIdFilterOption } from "../components/PropertyIdFilter";
import { getVisitsPropertyOptions } from "./filterVisitsByProperty";
import { getPropertyFilterLabel } from "./getPropertyFilterLabel";

export function getOfferPropertyFilterOptions(
  visitsData: IOwnerVisitsData | null
): PropertyIdFilterOption[] {
  if (!visitsData) {
    return [];
  }

  return getVisitsPropertyOptions(visitsData)
    .map((property) => ({
      propertyId: property.property_id,
      label: getPropertyFilterLabel(property),
    }))
    .sort((first, second) => first.label.localeCompare(second.label, "pt-BR"));
}
